import React, { FC, useContext } from 'react';
import styled from 'styled-components';
import { MainContent } from 'src/pages-all/master-page/components/main-content';
import { SubSectionHeadline } from 'src/pages-all/home/components/parts/default.parts';
import { translate, translationKeys } from 'logic/translations/translations.service';
import { useBreakpoints } from 'logic/hooks/use-breakpoints';
import { MainLayout } from 'src/pages-all/master-page/components/main-layout';
import { CmsContext } from 'logic/context/cms';
import { FAQList } from 'src/pages-all/faq/components/FAQList';
import { FAQWrapper } from 'src/pages-all/faq/components/FAQTypes';
import { ContactBox } from './ContactBox';
import { FaqPageSpec } from 'logic/faq-meta/faq-new';

const EliteFAQSection = styled(MainLayout)`
  padding: 0 16px;
`;

const FAQBody = styled.div``;

export const EliteFAQ: FC<{ hideContact?: boolean }> = ({ hideContact = false }) => {
  const { minTablet, min1024, maxMobileLarge } = useBreakpoints();
  const cms = useContext(CmsContext);
  const { onlineTutoringFAQ }: { onlineTutoringFAQ: FaqPageSpec } = cms;

  return (
    <>
      <EliteFAQSection id={'faq'}>
        <MainContent>
          <SubSectionHeadline
            headline={translate(translationKeys.homepage.faq.heading)}
            center
            reverseColor
            noHeadlineColor
            level={2}
          />
          <FAQBody>
            <FAQWrapper minTablet={minTablet} min1024={min1024} maxMobileLarge={maxMobileLarge}>
              {onlineTutoringFAQ.questions.map((q, i) => (
                <FAQList
                  active={1}
                  content={q.acceptedAnswer}
                  quoteAuthor={q.name}
                  idx={i}
                  key={i}
                />
              ))}
            </FAQWrapper>
          </FAQBody>
          {!hideContact && <ContactBox />}
        </MainContent>
      </EliteFAQSection>
    </>
  );
};
